import React from 'react';
import s from './UploadProgress.module.sass';
import { Progress } from 'antd';
 
const UploadProgress = ({
  fileName = 'cool file',
  progress = 30,
  status = 'active',
  errorMessage = ''
}) => {
  return (
    <ul className={s['file-list']}>
      <li className={s['file-list__file']}>
        <div className={s['file-container']}>
          <span className={s['file-name']}>{fileName}</span>
          <Progress percent={progress} status={status} />
          {status === 'exception' && errorMessage && (
            <span className={s['error-message']}>{errorMessage}</span>
          )}
        </div>
      </li>
    </ul>
  );
}
 
export default UploadProgress;